<dv-dialog-content>
  <dv-grid>
    <ag-grid-angular
      class="ag-theme-devinco grid-roles"
      [gridOptions]="gridOptions"
      (selectionChanged)="onSelectionChanged($event)">
    </ag-grid-angular>
  </dv-grid>
  <dv-button footer-right (click)="cancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="secondary"
    (click)="performSave()"
    [disabled]="!selectedNodes?.length">
    {{ 'General.Save' | translate }}
  </dv-button>
</dv-dialog-content>
